// --- Dependencies -------------------------------------------------------------------------------
import { NavLink, useLocation } from "react-router-dom";
// --- Our Modules --------------------------------------------------------------------------------
import constants from "@/config/constants";
import useNavTabs from "@/hooks/useNavTabs";
import usePopup from "@/hooks/usePopup";
import useTranslation from "@/hooks/useTranslation";
import { isSectionReentry } from "@/utils";
import Icon from "@/UI/atoms/Icon";
import MoreTabsPopup from "@/UI/popups/MoreTabsPopup";
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
/**
 * The phone-sized navigation. A sidebar toggle would sit at the top of the screen, the hardest place
 * to reach one-handed, so the destinations move down to where the thumb already rests.
 *
 * Four tabs plus "more", which opens the full list rather than only the leftovers — nothing should be
 * reachable solely by remembering it was pushed off the end.
 */
export default function BottomBar() {
    const t = useTranslation();
    const { tabs } = useNavTabs();
    const { pathname } = useLocation();
    const addComp = usePopup((state) => state.addComp);

    return (
        <nav className="bottom-bar">
            {tabs.slice(0, constants.bottomBarTabs).map((tab) => (
                <NavLink
                    key={tab.path}
                    to={tab.path}
                    end={tab.path === "/"}
                    replace={isSectionReentry(tab.path, pathname)}
                    className={({ isActive }) => `bottom-bar__tab${isActive ? " bottom-bar__tab--active" : ""}`}
                >
                    <Icon name={tab.icon} size={22} />
                    <span className="bottom-bar__label">{tab.label}</span>
                </NavLink>
            ))}

            <button
                type="button"
                className="bottom-bar__tab"
                onClick={() => addComp({ name: "more-tabs", Component: MoreTabsPopup, place: "end", anim: "endSlide" })}
            >
                <Icon name="menu" size={22} />
                <span className="bottom-bar__label">{t.common.more}</span>
            </button>
        </nav>
    );
}
